<template>
	<div class="grid-flex-container">
		<div class="grid-toolbar mb-4">
			<v-tabs style="flex-grow: 0" v-model="tab">
				<v-tab>Details</v-tab>
				<v-tab v-if="$route.params.id != null">Fields</v-tab>
				<v-tab v-if="$route.params.id != null">Interactions</v-tab>
				<v-tab v-if="$route.params.id != null">Assign Users</v-tab>
				<v-tab v-if="$route.params.id != null">Filters</v-tab>
				<v-tab v-if="false && $route.params.id != null"
					>Mobile App Configuration</v-tab
				>
			</v-tabs>
		</div>
		<v-container :fluid="true" class="grid-flex-container pt-0 d-flex">
			<inventory-form-details v-if="tab == 0" />
			<inventory-form-form-fields v-if="tab == 1" />
			<inventory-form-interactions v-if="tab == 2" />
			<inventory-form-assign-users v-if="tab == 3" />
			<inventory-form-filters v-if="tab == 4" />
			<mobile-app-config v-if="tab == 5" />
		</v-container>
	</div>
</template>
<script>
import InventoryFormDetails from './formDetails/InventoryFormDetails.vue';
import InventoryFormFormFields from './formFields/InventoryFormFormFields.vue';
import InventoryFormInteractions from './interactions/InventoryFormInteractions.vue';
import InventoryFormAssignUsers from './assignUser/InventoryFormAssignUsers.vue';
import InventoryFormFilters from './formFilters/InventoryFormFilters.vue';
import MobileAppConfig from './mobileAppConfig/MobileAppConfig.vue';
import { FormDetailsActions } from '../../../store/actions';

export default {
	components: {
		InventoryFormFormFields,
		InventoryFormInteractions,
		InventoryFormAssignUsers,
		InventoryFormDetails,
		InventoryFormFilters,
		MobileAppConfig,
	},
	name: 'AddInventoryForm',
	data() {
		return {
			tab: null,
			id: null,
			items: [
				{
					Name: 'Details',
					content: 'InventoryFormDetails',
				},
				{
					Name: 'Fields',
					content: 'InventoryFormFormFields',
				},
				{
					Name: 'Interactions',
					content: 'InventoryFormInteractions',
				},
				{
					Name: 'Assign Users',
					content: 'InventoryFormAssignUsers',
				},
			],
		};
	},
	computed: {
		formId() {
			return this.$route.params.id || null;
		},
	},
	mounted() {
		this.$store.dispatch(FormDetailsActions.LOAD, this.formId);
	},
	destroyed() {
		this.$store.dispatch(FormDetailsActions.CLEAR);
	},
};
</script>
<style lang="scss">
.v-tabs-bar {
	height: 41px;
}
.grid-flex-container {
	overflow-y: scroll;
}
</style>
